export enum SCORE_ENDPOINT {
    LIST_SCORE = "score",
    SAVE_SCORE = "score/save"
}